import { render, staticRenderFns } from "./hqStuHealthUserEdit.vue?vue&type=template&id=7b7a42ca&scoped=true"
import script from "./hqStuHealthUserEdit.vue?vue&type=script&lang=js"
export * from "./hqStuHealthUserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7a42ca",
  null
  
)

export default component.exports